import { getFormHelpTextColor } from 'src/components/utils/stylingFunctions';
import { textStyleCss } from 'src/theme/atlas';
import { FormState } from 'src/types';
import styled from 'styled-components';

export type HelpTextSize = 'small' | 'medium' | 'large';

export const HelpTextWrapper = styled.div<{
  hasTitle: boolean;
  state: FormState;
  $margin: string;
}>`
  display: flex;
  margin: ${({ $margin }) => ($margin ? $margin : '8px 0 8px 0')};
  align-items: ${({ hasTitle }) => (hasTitle ? 'flex-start' : 'center')};
  color: ${({ state, theme }) => getFormHelpTextColor(state, theme)};
`;

export const HelpTextContent = styled.div<{ hasPadding: boolean }>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ hasPadding }) => (hasPadding ? '6px' : '')};
`;

export const StyledTitle = styled.p<{
  state: FormState;
  textSize: HelpTextSize;
}>`
  ${({ theme, textSize }) => {
    switch (textSize) {
      case 'small':
        return textStyleCss(theme.atlas.typography.semantic.caption);
      case 'medium':
        return textStyleCss(theme.atlas.typography.semantic.bodySmall);
      case 'large':
        return textStyleCss(theme.atlas.typography.semantic.body);
      default:
        return textStyleCss(theme.atlas.typography.semantic.caption);
    }
  }};
  font-weight: 600;
  color: ${({ state, theme }) => getFormHelpTextColor(state, theme)};
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  text-align: left;
`;

export const StyledText = styled.p<{
  state: FormState;
  textSize: HelpTextSize;
}>`
  ${({ theme, textSize }) => {
    switch (textSize) {
      case 'small':
        return textStyleCss(theme.atlas.typography.semantic.caption);
      case 'medium':
        return textStyleCss(theme.atlas.typography.semantic.bodySmall);
      case 'large':
        return textStyleCss(theme.atlas.typography.semantic.body);
      default:
        return textStyleCss(theme.atlas.typography.semantic.caption);
    }
  }};
  color: ${({ state, theme }) => getFormHelpTextColor(state, theme)};
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  text-align: left;
`;
